import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Toolbar, MenuItem } from "@material-ui/core";
import { SecondaryButton } from "../../common/restyled-mui/CustomButton";
import {
    CustomSelect,
    CustomInputLabel,
} from "../../common/restyled-mui/CustomInputs";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing(0, 4),
        height: 56,
        minHeight: 56,
        borderBottom: `1px solid ${theme.palette.generalUi.borders}`,
        backgroundColor: theme.palette.generalUi.background,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    title: {
        padding: 0,
        fontSize: 24,
        flex: "0 0 auto",
    },
    middleSection: {
        display: "flex",
        justifyContent: "center",
        flex: "1 1 auto",
    },
    appbarContainer: {
        top: 0,
        position: "sticky",
        width: "100%",
    },
    percentileControl: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    percentileLabel: {
        fontSize: 16,
        fontWeight: 500,
        margin: 0,
        marginBottom: 0,
        marginRight: theme.spacing(2),
    },
    downloadDataButton: {
        width: "175px",
    },
}));

const HindcastsTableTopbar = (props) => {
    const classes = useStyles(props);
    const {
        title,
        selectedPercentile,
        handlePercentileChange,
        percentileOptions,
        downloadAnalysisData,
    } = props;

    return (
        <>
            <div>
                <Toolbar className={classes.root}>
                    <Typography variant="h3" className={classes.title}>
                        {title}
                    </Typography>
                    <div className={classes.middleSection}>
                        <div className={classes.percentileControl}>
                            <CustomInputLabel
                                className={classes.percentileLabel}
                            >
                                Percentiles:
                            </CustomInputLabel>
                            <CustomSelect
                                value={selectedPercentile}
                                onChange={handlePercentileChange}
                            >
                                {percentileOptions.map((option) => (
                                    <MenuItem
                                        key={option}
                                        value={option}
                                        className={classes.selectMenuItem}
                                    >
                                        {option}
                                    </MenuItem>
                                ))}
                            </CustomSelect>
                        </div>
                    </div>
                    <SecondaryButton
                        onClick={downloadAnalysisData}
                        className={classes.downloadDataButton}
                    >
                        Download Analysis
                    </SecondaryButton>
                </Toolbar>
            </div>
        </>
    );
};

export default HindcastsTableTopbar;
